module.exports = __webpack_public_path__ + "img/knife.bone.ba8ac3e5.png";